import React, { useState, useMemo} from "react";
import { Button } from "../../../../../components/RegularComponents";
import ApplicationStatusComponent from "../../../BLTCommon/ApplicationStatus";
import { fetchApplicationWithId } from "../../../../../redux/slice/bltHomeSlice"
import { addAgentApplication } from '../../../../../redux/slice/additionalApplicationsSlice'
import { useDispatch } from "react-redux";
import { APPLICATION_STATUS_APPROVED_ISSUED } from "../../../../../app/constants";
import { licenceSubTypeString } from "../../../../../app/utils";

export const CollectorsTable = (props) => {
    const { collectors, setCollector, showApplicationType} = props;
    const dispatch = useDispatch()

    const [sortingParameters, setSortingParameters] = useState({})

    const headers = useMemo(() => {
        const h = []

        h.push({
            key: "contactName",
            title: "Name",
            sort: (isAscending) => (a, b) => {
                const aStr = a.contactName
                const bStr = b.contactName
                return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
            }
        })

        if(showApplicationType) {
            h.push({
                key: "licencingSubType",
                title: "Type",
                sort: (isAscending) => (a, b) => {
                    const aStr = licenceSubTypeString(a.licencingSubType)
                    const bStr = licenceSubTypeString(b.licencingSubType)
                    return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
                },
                format : (licencingSubType) => licenceSubTypeString(licencingSubType) 
            })
        }

        h.push({
            key: "applicationStatus",
            title: "Status",
            sort: (isAscending) => (a, b) => {
                const aStr = a.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED ? a.licenceStatus : a.applicationStatus
                const bStr = b.applicationStatus === APPLICATION_STATUS_APPROVED_ISSUED ? b.licenceStatus : b.applicationStatus
                return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
            },
            format: (applicationStatus) => {
                return <ApplicationStatusComponent applicationStatus={applicationStatus} />
            }
        })

        h.push({
            key: "licenceNumber",
            title: "Licence number",
            sort: (isAscending) => (a, b) => {
                const aStr = a.licenceNumber
                const bStr = b.licenceNumber
                return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
            }
        })

        return h
    }, [showApplicationType])

    const rows = useMemo(() => {
        if (!collectors) { return [] }
        const header = headers.find(h => h.key === sortingParameters.key)
        if (!header) { return collectors }

        const newCollectors = [...collectors]
        newCollectors.sort(header.sort(sortingParameters.isAscending));
        return newCollectors

    }, [sortingParameters, collectors, headers])

    const getSortIcon = (header) => {
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        let modifiedSortingParams = { ...sortingParameters }

        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)
    }

    return (
        <div className="licence-application-details-panel">
            <div className="row section-row-margin">
                <table>
                    <thead>
                        <tr>
                            {headers.map((h) => (
                                <th key={h.key} onClick={headerClicked(h)}>
                                    <div style={{
                                        display: "inline-flex",
                                        width: "100%",
                                        gap: "0.5rem",
                                        alignItems: "center",
                                        cursor: "arrow"
                                    }}>
                                        <span>{h.title}</span> 
                                        <span style={{ marginRight: "0px 6px" }}>
                                            {getSortIcon(h)}
                                        </span>
                                    </div>
                                </th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                {headers.map((header, headerIndex) => {
                                    const key = header.key;
                                    let value = row[key]
                                    if(key === "applicationStatus") { 
                                        if(value === APPLICATION_STATUS_APPROVED_ISSUED
                                            && row['licenceStatus']) { 
                                            value = row['licenceStatus']
                                        }
                                    }
                                    
                                    const formattedValue = header.format ? header.format(value) : value;
                                    return <td key={headerIndex}>{formattedValue}</td>
                                })}
                                <td>
                                    <Button id={`licence-suspension-detail-${index}`}
                                        className={"licence-queue-review-readonly-button"}
                                        buttonType="regular_primary"
                                        text="Details"
                                        onClick={() => {
                                            if(!row.businessLicenceData) {
                                                dispatch(fetchApplicationWithId(row.id))
                                                    .then(applicationData => {
                                                        dispatch(addAgentApplication(applicationData))
                                                        setCollector(applicationData)
                                                    })
                                            } else { 
                                                setCollector(row)
                                            }
                                        }} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                    <span>Client documents</span>
                </div>

                <div className="collector-licence-col col-md-6" style={{ display: "flex", flexDirection: "column" }}>
                    {documents.map((document, index) => (
                        <div key={index}>
                            <DownloadFileNameLink
                                id={"supporting-document-download-file-" + document.filename}
                                // key={"supporting-document-download-file-" + document.filename}
                                file={document}
                            />
                        </div>
                    ))}
                </div> */}
            </div>



        </div>
    )
}